import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Box from '../components/Box.jsx';

export default function SoundboardFruit() {
  return (
    <div className='page-content-soundboard'> 
    
    <Container>
      <Row className="g-4 pt-4">
        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Apple'} 
        imageAlt={'Apple'} 
        imageStatic={'./images/apple-static.png'} 
        imageGif={'./images/apple-gif.gif'}
        audioVoice={'/audio/apple.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Watermelon'} 
        imageAlt={'Watermelon'} 
        imageStatic={'./images/watermelon-static.png'} 
        imageGif={'./images/watermelon-gif.gif'}
        audioVoice={'/audio/watermelon.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Banana'} 
        imageAlt={'Banana'} 
        imageStatic={'./images/banana-static.png'} 
        imageGif={'./images/banana-gif.gif'}
        audioVoice={'/audio/banana.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Mango'} 
        imageAlt={'Mango'} 
        imageStatic={'./images/mango-static2.png'} 
        imageGif={'./images/mango-gif2.gif'}
        audioVoice={'/audio/mango.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Cherry'} 
        imageAlt={'Cherry'} 
        imageStatic={'./images/cherry-static.png'} 
        imageGif={'./images/cherry-gif.gif'}
        audioVoice={'/audio/cherry.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Lemon'} 
        imageAlt={'Lemon'} 
        imageStatic={'./images/lemon-static.png'} 
        imageGif={'./images/lemon-gif.gif'}
        audioVoice={'/audio/lemon.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Strawberry'} 
        imageAlt={'Strawberry'} 
        imageStatic={'./images/strawberry-static.png'} 
        imageGif={'./images/strawberry-gif.gif'}
        audioVoice={'/audio/strawberry.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Grape'} 
        imageAlt={'Grape'} 
        imageStatic={'./images/grape-static.png'} 
        imageGif={'./images/grape-gif.gif'}
        audioVoice={'/audio/grape.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Kiwi'} 
        imageAlt={'Kiwi'} 
        imageStatic={'./images/kiwi-static.png'} 
        imageGif={'./images/kiwi-gif.gif'}
        audioVoice={'/audio/kiwi.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Tangerine'} 
        imageAlt={'Tangerine'} 
        imageStatic={'./images/tangerine-static.png'} 
        imageGif={'./images/tangerine-gif.gif'}
        audioVoice={'/audio/tangerine.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Dates'} 
        imageAlt={'Dates'} 
        imageStatic={'./images/dates-static.png'} 
        imageGif={'./images/dates-gif.gif'}
        audioVoice={'/audio/dates.mp3'}/>
        </Col>

        

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Avocado'} 
        imageAlt={'Avocado'} 
        imageStatic={'./images/avocado-static.png'} 
        imageGif={'./images/avocado-gif.gif'}
        audioVoice={'/audio/avocado.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Pineapple'} 
        imageAlt={'Pineapple'} 
        imageStatic={'./images/pineapple-static.png'} 
        imageGif={'./images/pineapple-gif.gif'}
        audioVoice={'/audio/pineapple.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Raspberry'} 
        imageAlt={'Raspberry'} 
        imageStatic={'./images/raspberry-static.png'} 
        imageGif={'./images/raspberry-gif.gif'}
        audioVoice={'/audio/raspberry.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Coconut'} 
        imageAlt={'Coconut'} 
        imageStatic={'./images/coconut-static.png'} 
        imageGif={'./images/coconut-gif.gif'}
        audioVoice={'/audio/coconut.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Orange'} 
        imageAlt={'Orange'} 
        imageStatic={'./images/orange-static.png'} 
        imageGif={'./images/orange-gif.gif'}
        audioVoice={'/audio/orange.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Fig'} 
        imageAlt={'Fig'} 
        imageStatic={'./images/fig-static.png'} 
        imageGif={'./images/fig-gif.gif'}
        audioVoice={'/audio/fig.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Pear'} 
        imageAlt={'Pear'} 
        imageStatic={'./images/pear-static.png'} 
        imageGif={'./images/pear-gif.gif'}
        audioVoice={'/audio/pear.mp3'}/>
        </Col>
      </Row>
      
      
    </Container>

    </div>
  )
}
